import styled from 'styled-components'

interface IStatusCardLegacyStyledProps {}

export const StatusCardLegacyStyled = styled.div<IStatusCardLegacyStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .status-card-container {
    display: grid;

    grid-template-areas: 'left content right' '. collapsible .';
    grid-template-columns: minmax(0, max-content) minmax(0, 1fr) minmax(
        0,
        max-content
      );

    margin: 0 -0.5em;
  }
`
